// Ad attribution for every lead form. Ads may land on any page (the home page, a
// legacy page), so the tags are captured once per browser session on the first page
// that carries them, and every later form reads them back.
const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'] as const;
const STORE = 'sp_ad_tags';

function fromUrl(): Record<string, string> {
  const q = new URLSearchParams(window.location.search);
  const out: Record<string, string> = {};
  for (const k of KEYS) {
    const v = q.get(k);
    if (v) out[k] = v.slice(0, 200);
  }
  return out;
}

/** Called once at boot: first touch wins for the rest of the session. */
export function captureAdTags() {
  const found = fromUrl();
  if (!Object.keys(found).length) return;
  try {
    if (!sessionStorage.getItem(STORE)) {
      sessionStorage.setItem(STORE, JSON.stringify({ ...found, landing: window.location.pathname }));
    }
  } catch {
    /* storage blocked: adTags() still reads the current URL */
  }
}

/** The session's first-touch tags, or the current URL's when storage is unavailable. */
export function adTags(): Record<string, string> {
  try {
    const saved = sessionStorage.getItem(STORE);
    if (saved) return JSON.parse(saved) as Record<string, string>;
  } catch {
    /* fall through */
  }
  return fromUrl();
}
